/**
 * FAQ.jsx — Workshop Details & FAQ Promo Tile
 *
 * Props:
 *   onOpenFAQ {Function} — called when the user clicks "Browse FAQ"
 */
import { useFAQContent } from '../services/firestore';

export default function FAQTile({ onOpenFAQ }) {
  const { faq } = useFAQContent();
  const { tile } = faq;

  return (
    <div className="section-pad">
      <div
        className="tile two-col-tile"
        style={{
          background: '#F9F2E9',
          border: 'none',
          position: 'relative',
          zIndex: 51,
        }}
      >
        {/* ── Left — heading and teaser copy ──────────────────────────── */}
        <div>
          <p
            style={{
              fontFamily: "'Raleway', sans-serif",
              fontWeight: 700,
              fontSize: '0.7rem',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: '#9C7A3C',
              marginBottom: 12,
            }}
          >
            {tile.label}
          </p>
          <h3
            style={{
              fontFamily: "'Titan One', sans-serif",
              fontWeight: 400,
              fontSize: '1.8rem',
              lineHeight: 1.1,
              color: '#1a1208',
              textTransform: 'uppercase',
              letterSpacing: '-0.01em',
              marginBottom: 12,
            }}
          >
            {tile.heading}
          </h3>
          <p
            style={{
              fontFamily: "'Raleway', sans-serif",
              fontWeight: 700,
              fontSize: 'clamp(1rem, 1.8vw, 1.1rem)',
              color: '#1a1208',
              lineHeight: 1.6,
            }}
          >
            {tile.description}
          </p>
        </div>

        {/* ── Right — quick teaser list + CTA button ───────────────────── */}
        <div>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: '0 0 28px',
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            {tile.teaserQuestions.map((q) => (
              <li
                key={q}
                style={{
                  fontFamily: "'Raleway', sans-serif",
                  fontWeight: 700,
                  fontSize: '0.9rem',
                  color: '#9C7A3C',
                  paddingLeft: 16,
                  borderLeft: '2px solid #9C7A3C55',
                }}
              >
                {q}
              </li>
            ))}
          </ul>
          <button className="thin-btn" onClick={onOpenFAQ}>
            {tile.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}
